/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MTP Service Mobile API
 * API REST pour l'espace client mobile - Migration Symfony 7.3
 * OpenAPI spec version: 2.0.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { ChartResponse } from '../placementApi.schemas.ts';

import getApiChartCategoryMutator from '.././mutator/placement-instance.ts';
import getApiChartMutator from '.././mutator/placement-instance.ts';

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Recuperation des donnees graphiques pour l'utilisateur authentifié, filtrées par categorie de placement (assurancevie, retraite, defiscalisation, immobilier, livret, bourse).
 * @summary Recuperation unitaire d'un jeu de donnee de type Charts pour une famille
 */
export const getApiChartCategory = (category: string, signal?: AbortSignal) => {
  return getApiChartCategoryMutator<ChartResponse | void>({ url: `/api/chart/${category}`, method: 'GET', signal });
};

export const getGetApiChartCategoryQueryKey = (category: string) => {
  return [`/api/chart/${category}`] as const;
};

export const getGetApiChartCategoryQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiChartCategory>>,
  TError = void,
>(
  category: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChartCategory>>, TError, TData>> }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiChartCategoryQueryKey(category);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChartCategory>>> = ({ signal }) =>
    getApiChartCategory(category, signal);

  return {
    queryKey,
    queryFn,
    enabled: category !== null && category !== undefined,
    staleTime: 1800000,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getApiChartCategory>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetApiChartCategoryQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChartCategory>>>;
export type GetApiChartCategoryQueryError = void;

export function useGetApiChartCategory<TData = Awaited<ReturnType<typeof getApiChartCategory>>, TError = void>(
  category: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChartCategory>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChartCategory>>,
          TError,
          Awaited<ReturnType<typeof getApiChartCategory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiChartCategory<TData = Awaited<ReturnType<typeof getApiChartCategory>>, TError = void>(
  category: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChartCategory>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChartCategory>>,
          TError,
          Awaited<ReturnType<typeof getApiChartCategory>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiChartCategory<TData = Awaited<ReturnType<typeof getApiChartCategory>>, TError = void>(
  category: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChartCategory>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation unitaire d'un jeu de donnee de type Charts pour une famille
 */

export function useGetApiChartCategory<TData = Awaited<ReturnType<typeof getApiChartCategory>>, TError = void>(
  category: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChartCategory>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiChartCategoryQueryOptions(category, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

/**
 * Recuperation des donnees graphiques pour l'utilisateur authentifie, incluant la valorisation, l'evolution, les periodes d'evolution et les points de donnees.
 * @summary Recuperation unitaire d'un jeu de donnee de type Charts
 */
export const getApiChart = (signal?: AbortSignal) => {
  return getApiChartMutator<ChartResponse>({ url: `/api/chart`, method: 'GET', signal });
};

export const getGetApiChartQueryKey = () => {
  return [`/api/chart`] as const;
};

export const getGetApiChartQueryOptions = <TData = Awaited<ReturnType<typeof getApiChart>>, TError = void>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChart>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiChartQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiChart>>> = ({ signal }) => getApiChart(signal);

  return { queryKey, queryFn, staleTime: 1800000, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiChart>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiChartQueryResult = NonNullable<Awaited<ReturnType<typeof getApiChart>>>;
export type GetApiChartQueryError = void;

export function useGetApiChart<TData = Awaited<ReturnType<typeof getApiChart>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChart>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChart>>,
          TError,
          Awaited<ReturnType<typeof getApiChart>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiChart<TData = Awaited<ReturnType<typeof getApiChart>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChart>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiChart>>,
          TError,
          Awaited<ReturnType<typeof getApiChart>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiChart<TData = Awaited<ReturnType<typeof getApiChart>>, TError = void>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChart>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Recuperation unitaire d'un jeu de donnee de type Charts
 */

export function useGetApiChart<TData = Awaited<ReturnType<typeof getApiChart>>, TError = void>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiChart>>, TError, TData>> },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiChartQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
